import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { SuccessResponse } from 'src/app/common/models/SuccessRespons';
import { LocalStorageService } from 'src/app/common/services/local-storage.service';
import { tap } from 'rxjs';
import { Router } from '@angular/router';
import { AuthRoutes } from 'src/app/auth/auth.routes';
import { Api, ApigatewayService } from 'src/app/common/services/apigateway.service';
import { DOCUMENT } from '@angular/common';
import { MenuService } from 'src/app/menus/menu/menu.service';
import { isCountryBR, isCountryMX, isCountryPE } from 'src/app/common/util/util';
import { DataManagerService } from '../data-manager.service';

@Injectable({ providedIn: 'root' })
export class SecurityService {
  private window: Window;

  routes = AuthRoutes.ROUTES;

  orderUser = [];

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private httpClient: HttpClient,
    private localStorageService: LocalStorageService,
    private dataManagerService: DataManagerService,
    private router: Router,
    private apigatewayService: ApigatewayService,
    private menuService: MenuService
  ) {}

  // private bestApi = this.apigatewayService.getBestApiGateway();
  // private BASE_URL = `${this.bestApi}${env.ACCESS_CONTROL_API_BASE_URL}`;
  private BASE_URL = `${this.apigatewayService.getApiUrl(Api.ACCESS_CONTROL)}`;

  logout() {
    // const token = this.localStorageService.get('sessionToken');
    // const URL = `${this.BASE_URL}/logout`;
    // this.httpClient.post<SuccessResponse>(URL, { token }).subscribe((_) => {
    this.cleanUserSession();
    this.removeStorageSession();
    if (isCountryMX()) {
      this.router.navigate([this.routes.LoginMx.fullPath]);
    } else if (isCountryBR()) {
      this.router.navigate([this.routes.LoginBr.fullPath]);
    } else if (isCountryPE()) {
      this.router.navigate([this.routes.LoginPe.fullPath]);
    } else {
      this.router.navigate([this.routes.Login.fullPath]);
    }
  }

  setlogout() {
    this.notifyLogoutDatadog();
    const token = this.localStorageService.get('sessionToken');
    const URL = `${this.BASE_URL}/logout`;
    return this.httpClient.post<SuccessResponse>(URL, { token });
  }

  // refreshToken(captchaToken: string) {
  //   const URL = `${this.BASE_URL}/refresh-token`;

  //   return this.httpClient.post<SuccessResponse>(URL, { captchaToken }).pipe(
  //     tap(({ result }) => {
  //       this.localStorageService.set('sessionToken', result.token);
  //       this.localStorageService.set('sessionExpireIn', result.expireIn);
  //     })
  //   );
  // }

  refreshToken(captchaToken: string) {
    const URL = `${this.BASE_URL}/refresh-token`;

    return this.httpClient.post<SuccessResponse>(URL, { captchaToken }).pipe(
      tap(({ result }) => {
        this.localStorageService.set('sessionToken', result.token);
        this.localStorageService.set('sessionExpireIn', result.expireIn);
      })
    );
  }

  private verifyTokenHasExpired(): Promise<any> {
    const URL = `${this.BASE_URL}/`;

    return Promise.resolve();
  }

  private removeStorageSession() {
    this.dataManagerService.setQuote();
    // this.localStorageService.remove('currentQuote');
    // this.localStorageService.remove('planSelected');
    // this.localStorageService.remove('sessionToken');
    // this.localStorageService.remove('sessionExpireIn');
    // this.localStorageService.remove('steps');
    // this.localStorageService.remove('brokerSessionInfo');
    this.localStorageService.clear();
  }

  cleanUserSession() {
    // this.window.onload = null;
    // this.window.removeAllListeners('scroll');
    this.menuService.setCurrentMenu('main');
    // this.document.onmousemove = null;
    // this.document.onkeydown = null;
    // this.document.onclick = null;
  }

  notifyLogoutDatadog() {
    (window as any).DD_RUM && (window as any).DD_RUM.clearUser();
  }
}
